exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.external-directory-page[data-v-41c0b0e0]{height:100%}div.content[data-v-41c0b0e0]{padding-top:58px;padding-bottom:67px;background-color:#fff;min-height:100%}", ""]);

// exports
